// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"37":"ef007daa","55":"d76255eb","71":"6fee5066","181":"9c6372f3","247":"49d3b84a","371":"4e2f0e23","384":"9c07e665","412":"17585f60","423":"cc556233","428":"160f8361","435":"67cb6098","620":"7a489ed5","646":"8e412b30","704":"fc069c1e","745":"d2b2ef12","936":"3ce0a173"}[chunkId] + ".js";
};